import React from "react";
import '../index.css';
import Footer from "./footer";
import Navbar from "./navbar";
import { ChevronDown } from 'lucide-react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from "axios";
import baseUrl from "../base_url";
import SingleOrderSkeleton from "./components/singleOrderSkeleton";

function SingleOrder() {


  const navigate = useNavigate();

  React.useEffect(() => {
    const getUser = async() => {
    const accessToken = localStorage.getItem("accessToken");
      try {
        await axios.get(`${baseUrl}api/auth/isLoggedIn`, {
            headers: {
            Authorization: `Bearer ${accessToken}`,
            },
            withCredentials: true, 
        });
      } catch(err) {
        navigate("/login");
        console.log("error while checking if logged in");
        console.log(err);
      }
    };
    getUser();
  }, [navigate]);

  
  
  const { id } = useParams();
  const [order, setOrder] = React.useState(null);
  const [address, setAddress] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  
  
    React.useEffect(() => {
        async function getOrders() {
            try {
                const accessToken = localStorage.getItem("accessToken")
                const response = await axios.post(
                    `${baseUrl}api/orders/get-order/${id}`,
                    {},
                    { withCredentials: true  ,     headers: {Authorization: `Bearer ${accessToken}`,'Content-Type': 'application/json',},}
                );
                setOrder(response?.data?.data);
                setAddress(response?.data?.data?.address?.[0]);
                setLoading(false);
            } catch (err) {
                console.log("error fetching orders list");
                setLoading(false);
            }
        }
        getOrders();
    }, [id]);

    if (loading) {
        return (
            <div className="bg-gray-100 min-h-screen">
                <Navbar />
                    <SingleOrderSkeleton/>
                <Footer />
            </div>
        );
    }

    if (!order) {
        return (
            <div className="bg-[#FAF9F8] min-h-screen">
                <Navbar />
                <div className="container mx-auto px-4 py-6 max-w-6xl">
                    <p>Order not found.</p>
                </div>
                <Footer />
            </div>
        );
    }
  const orderStatus = order?.status;
  const isDelivered = orderStatus === "Delivered";
  const isShipped = orderStatus === "Shipped";
  const isProcessing = orderStatus === "Processing";
  const isCancelled = orderStatus === "Canceled";
  const isPlaced = orderStatus === "Placed";
  const returnRequested = orderStatus === "Return Requested";
  const returnApproved = orderStatus === "Return Approved";
  const returnInitiated = orderStatus === "Return Pickup Initiated";
  const refunded = orderStatus === "Refunded";
  const returnInProgress = orderStatus === "Return in Progress";
  const returnRejected = orderStatus === "Return Rejected";

    // Format the date
    const orderDate = new Date(order.createdAt).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });
    // console.log(order)
  const deliveryDate = order?.deliveryDate ? new Date(order.deliveryDate).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  }) : null;

    async function HandleCancelReturn(order){
        const confirm = window.confirm("Are you sure that you want to cancel the return request ?")

        if(confirm){
            try{
                const accessToken = localStorage.getItem("accessToken");

                const response = await axios.post(
                `${baseUrl}api/orders/cancel-return/${order.returnId}`,
                {}, // empty body if not needed
                {
                    withCredentials: true,
                    headers: {
                    Authorization: `Bearer ${accessToken}`,
                    'Content-Type': 'application/json',
                    },
                }
                );

                console.log(response)
            }catch(err){
                console.log("error while cancelling the return")
                console.log(err)
            }
        }
    }

      const canBeReturned = (order) => {
        const deliveryDate = new Date(order.deliveryDate);
        const currentDate = new Date();
        const timeDifference = currentDate - deliveryDate;
        const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24)) + 1;
    return daysDifference <= 7;
    };

    const canReturned = canBeReturned(order)

  const handleInvoice = async () => {
    try {



      const invoiceUrl =  order.invoice;
      // console.log('Invoice URL:', invoiceUrl);

      if (invoiceUrl) {
        // Second request to download the PDF
        const pdfResponse = await axios.get(invoiceUrl, {
          responseType: 'blob' 
        });

        // Create a blob URL and trigger download
        const url = window.URL.createObjectURL(new Blob([pdfResponse.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `invoice_${id}.pdf`);
        document.body.appendChild(link);
        link.click();

        // Clean up
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);

        alert('Invoice downloaded successfully!');
      } else {
        throw new Error('No invoice URL received');
      }
    } catch (err) {
      console.error('Failed to download invoice:', err);
      alert('Failed to download invoice');
    } 
  };

    return (
        <div className="bg-[#FAF9F8] min-h-screen">
            <Navbar />
            
            <div className="container mx-auto px-4 py-6 max-w-6xl ">
                {/* Breadcrumb */}
                <div className="flex items-center text-xs md:text-sm mb-4">
                    <a href="/profile" className="text-purple-900 hover:underline">Your Account</a>
                    <span className="mx-2">›</span>
                    <a href="/orders" className="text-purple-800 hover:underline">Your Orders</a>
                    <span className="mx-2">›</span>
                    <span className="text-purple-700 ">Order Details</span>
                </div>

                {/* Order Title & Info */}
                <div className="mb-4">
                    <h1 className="font-bold text-gray-800 text-xl md:text-2xl">Order Details</h1>
                    <div className="flex flex-wrap items-center justify-between mt-2">
                        <div className="flex flex-wrap items-center text-gray-600 text-xs md:text-sm">
                            <p className="mr-4">Order placed {orderDate}</p>
                            <p>Order number {order._id}</p>
                        </div>
                        <button onClick={handleInvoice} className="flex pt-2 items-center text-blue-600 text-xs md:text-sm">
                            Invoice <ChevronDown size={16} />
                        </button>
                    </div>
                </div>

                {/* Order Details Card */}
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                        {/* Shipping Address */}
                        <div>
                            <h3 className="font-bold text-gray-800 mb-2 text-ls md:text-xl ">Shipping Address</h3>
                            {address && (
                                <div className="text-sm md:text-lg">
                                    <p>{address.fullName}</p>
                                    <p>{address.streetAddress}</p>
                                    <p>{address.city}, {address.state} {address.postalCode}</p>
                                    <p>{address.country}</p>
                                    <p>Phone: {address.phone}</p>
                                </div>
                            )}
                        </div>

                        {/* Payment Methods */}
                        <div>
                            <h3 className="font-bold text-gray-800 mb-2 text-ls md:text-xl">Payment Methods</h3>
                            {order.paymentMethod[0] !== "COD"  && <p className="text-sm md:text-lg">Order ID: {order.razorpayOrderId || "N/A"}</p>}
                            <p className="text-sm md:text-lg">Payment Status: {order.status}</p>
                            {order.paymentMethod.length > 0 && <p className="text-sm md:text-lg">Payment Method: {order.paymentMethod[0]}</p>}
                        </div>

                        {/* Order Summary */}
                        <div>
                            <h3 className="font-bold text-gray-800 mb-2 text-ls md:text-xl">Order Summary</h3>
                            <table className="w-full text-sm md:text-lg">
                                <tbody>
                                    <tr>
                                        <td className="py-1">Item(s) Subtotal:</td>
                                        <td className="text-right">₹{order.totalAmount.toFixed(2)}</td>
                                    </tr>
                                    <tr>
                                        <td className="py-1">Shipping:</td>
                                        <td className="text-right">₹0.00</td>
                                    </tr>
                                    <tr>
                                        <td className="py-1">Cash/Pay on Delivery fee:</td>
                                        <td className="text-right">₹0.00</td>
                                    </tr>
                                    <tr className="border-t border-gray-200">
                                        <td className="pt-2 font-medium">Total:</td>
                                        <td className="pt-2 text-right font-medium">₹{order.totalAmount.toFixed(2)}</td>
                                    </tr>
                                    <tr>
                                        <td className="pt-1 font-bold">Grand Total:</td>
                                        <td className="pt-1 text-right font-bold">₹{order.totalAmount.toFixed(2)}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                {/* Delivery Status & Product Details */}
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                    <div className="mb-4 flex flex-row justify-between">
                        <div className="flex flex-col">
                        <h2 className="text-lg font-bold">Status: {
                            isDelivered && "Delivered" ||
                            isShipped && "Shipped" ||
                            isProcessing && "Processing" ||
                            isCancelled && "Cancelled" ||
                            isPlaced && "Placed" ||
                            returnRequested && "Return Requested" ||
                            returnApproved && "Return Approved" ||
                            returnInitiated && "Return Pickup Initiated" ||
                            refunded && "Refunded" ||
                            returnInProgress && "Picked Up" ||
                            returnRejected && "Return Rejected" ||
                            order.status
                        }</h2>
                        
                        {isPlaced && <p className="text-sm text-gray-600">Your order is placed</p>}
                        {isDelivered && <p className="text-sm text-gray-600">Package was handed to resident on {deliveryDate}</p>}
                        {isShipped && <p className="text-sm text-gray-600">Your package is on the way</p>}
                        {isProcessing && <p className="text-sm text-gray-600">Your order is being processed</p>}
                        {isCancelled && <p className="text-sm text-gray-600">This order has been cancelled</p>}
                        {returnRequested && <p className="text-sm text-gray-600">Awaiting Confirmation</p>}
                        {returnApproved && <p className="text-sm text-gray-600">Pickup will be initiated shortly.</p>}
                        {returnInitiated && <p className="text-sm text-gray-600">Product will be picked up shortly.</p>}
                        {refunded && <p className="text-sm text-gray-600">Refund will be credited shortly, if it was a COD order contact us on whatsapp</p>}
                        {returnInProgress && <p className="text-sm text-gray-600">Item has been picked up</p>}
                        {returnRejected && <p className="text-sm text-gray-600">Return request was rejected, contact us on whatsapp</p>}
                        </div>

                        {order.tracking !== "NA" && order.status === "Shipped" && <a href={order.tracking} className="border border-gray-300 rounded py-2 px-4 flex items-center justify-center text-sm hover:bg-gray-50 text-center">Track package</a>}
                        {(order.status === "Delivered" || order.status === "Return Requested") && (canReturned) && <a href={`/return/${order._id}`} className="border border-gray-300 rounded py-2 px-4 flex items-center justify-center text-sm hover:bg-gray-50 text-center">Return</a>}
                    </div>


                    {/* Product Details */}
                    {order.cart.map(item => {
                        // console.log(item)
                        return(
                        <div key={item._id} className="flex flex-col md:flex-row border-t border-gray-200 pt-6 pb-6">
                            <div className="md:w-24 flex-shrink-0 mb-4 md:mb-0 md:mr-6">
                                <img src={item.image} alt={item.title} className="w-full" />
                            </div>
                            
                            <div className="flex-grow">
                                <a href={`/productpage/${item.productId}`} className="text-black font-medium decoration-[none] hover:underline text-sm md:text-base mb-1 block ">{item.title}</a>
                                <p className="text-xs md:text-sm text-gray-600 mb-1">Quantity: {item.quantity}</p>
                                {
                                 item.returned === false &&
                                    <p className="text-xs md:text-sm text-gray-600 mb-2">
                                        Return eligible until {new Date(new Date(order.createdAt).getTime() + 30*24*60*60*1000).toLocaleDateString()}
                                    </p>
                                }
                                {
                                 item.returned === true &&
                                    <p className="text-xs md:text-sm text-gray-600 mb-2">
                                        Return status : {order.status}
                                    </p>
                                }
                                <p className="font-bold mb-4 text-sm">₹{item.price.toFixed(2)}</p>
                                <div className="md:hidden">
                                    <button className="w-full mb-2 border border-gray-300 rounded py-1 px-3 text-xs md:text-sm">View your item</button>
                                </div>
                            </div>

                            <div className="md:w-64 flex-shrink-0 mt-4 md:mt-0 md:ml-4">
                                <div className="flex flex-col space-y-2">
                                    {
                                        item.returned === true &&
                                        <button onClick={()=>HandleCancelReturn(item)} href={`/productpage/${item.productId}`} className="md:block border border-gray-300 rounded py-2 px-4 text-sm flex items-center justify-center text-center  hover:bg-gray-50">Cancel Return</button>
                                    }
                                </div>
                            </div>
                        </div>
                    )})}
                </div>
            </div>
            
            <Footer />
        </div>
    );
}

export default SingleOrder;